import { useState } from "react";
import { useCompositionStore } from "../../stores/compositionStore.js";
import { Button } from "../../ui/Button.js";
import { Card } from "../../ui/Card.js";

export function ExportPanel(): JSX.Element {
  const projectId = useCompositionStore((s) => s.projectId);
  const jobs = useCompositionStore((s) => s.jobs);
  const [jobId, setJobId] = useState<string | null>(null);

  const job = jobId ? (jobs[jobId] ?? null) : null;
  const isRunning = job?.status === "running" || job?.status === "pending";
  const outputHash =
    job?.status === "completed" && job.outputHash !== undefined ? job.outputHash : null;

  async function onExport(): Promise<void> {
    const pid = useCompositionStore.getState().projectId;
    if (!pid) return;
    const id = await useCompositionStore.getState().enqueueJob({
      projectId: pid,
      kind: "export",
      payload: { projectId: pid, bitrate: 320 },
    });
    setJobId(id);
  }

  const buttonLabel = isRunning ? `Exporting ${job?.percent ?? 0}%` : "Export MP3";

  return (
    <Card aria-label="Export">
      <div className="flex items-center gap-2">
        <Button
          onClick={() => {
            void onExport();
          }}
          disabled={!projectId || isRunning}
        >
          {buttonLabel}
        </Button>
        {outputHash !== null ? (
          <a
            className="text-xs text-accent underline"
            href={outputHash}
            download
            aria-label="Download export"
          >
            Download
          </a>
        ) : null}
      </div>
    </Card>
  );
}
